
import { DefaultState } from 'store/types';

export const CONFIRM_BOOKINGS_REQUEST = 'CONFIRM_BOOKINGS_REQUEST';
export const CONFIRM_BOOKINGS_SUCCESS = 'CONFIRM_BOOKINGS_SUCCESS';
export const CONFIRM_BOOKINGS_FAILURE = 'CONFIRM_BOOKINGS_FAILURE';


export interface ConfirmBookingsByIdsParams {
  bookingIds: string[];
  doNotSendNotificationToAssociate: boolean;
  doNotSendNotificationToCLC?: boolean;
};

export interface ConfirmBookingsData {
  
};

export type ConfirmBookingsState = DefaultState & {
  contents?: ConfirmBookingsData;
};

interface ConfirmBookingsDataRequest {
  type: typeof CONFIRM_BOOKINGS_REQUEST;
};

interface ConfirmBookingsDataSuccess {
  type: typeof CONFIRM_BOOKINGS_SUCCESS,
  contents: ConfirmBookingsData;
}

interface ConfirmBookingsDataFailure {
  type: typeof CONFIRM_BOOKINGS_FAILURE;
}

export type ConfirmBookingsActionTypes = ConfirmBookingsDataRequest | ConfirmBookingsDataSuccess | ConfirmBookingsDataFailure;